import { useEffect, type Dispatch, type SetStateAction } from "react";

import type {
  FormTemplateWithLongDescription,
  SelectedFormsObject,
  ValidationOutcome,
} from "@thalamos/aspire-common";

// Update the selected formTemplate when the value from the form selection input changes
export function useFormTemplateUpdater(
  formTemplateIdFromUrl: string | undefined,
  formInputValue: string,
  activeTemplates: FormTemplateWithLongDescription[],
  formTemplate: FormTemplateWithLongDescription | undefined,
  setFormTemplate: Dispatch<
    SetStateAction<FormTemplateWithLongDescription | undefined>
  >,
) {
  useEffect(() => {
    let template;
    if (formTemplateIdFromUrl) {
      template = activeTemplates.find((t) => t.id === formTemplateIdFromUrl);
    } else {
      template = activeTemplates.find(
        (t) => t.longDescription === formInputValue,
      );
    }
    if (template !== formTemplate) {
      setFormTemplate(template);
    }
  }, [formTemplateIdFromUrl, formInputValue]);
}

// Clear supporting documents form state when form template changes
export function useClearSupportingDocuments(
  formTemplateId: string | undefined,
  setSupportingFormsProvided: Dispatch<SetStateAction<boolean>>,
  setSelectedForms: Dispatch<SetStateAction<SelectedFormsObject[]>>,
  setNotSelectedReason: Dispatch<SetStateAction<string>>,
  setValidationOutcome: Dispatch<SetStateAction<ValidationOutcome[] | null>>,
) {
  // Clear supporting documents form state when form template changes
  useEffect(() => {
    setSupportingFormsProvided(false);
    setSelectedForms([]);
    setNotSelectedReason("");
    setValidationOutcome(null);
  }, [formTemplateId]);
}
